import React, { Component } from 'react'
import RoutingConstants from 'lib/RoutingConstants'
import { Elements, StripeProvider } from 'react-stripe-elements';
// eslint-disable-next-line import/no-named-as-default
import CardForm from './CardForm'

class BillPayment extends Component {
  constructor(props) {
    super(props)
    this.state = {
      ...props,
    }
  }

  // eslint-disable-next-line
  UNSAFE_componentWillReceiveProps(props) {
    this.setState({ ...props})
  }

  displayPlan() {
    const { subscriptionPlan, planId, isMobile } = this.state
    return(
      <div className="chs-plan">
        <h2>Choose your plan</h2>
        {
          subscriptionPlan.map(plan=>{

            const amount = `$${parseFloat(plan.total_price / 100).toFixed(2)}`
            const checked = plan.plan_id === planId
            const planClass = checked ? 'pln-info active' : 'pln-info'
            return(
              <div className={planClass} key={plan.plan_id}>
                <input 
                  type="radio" 
                  name="plan" 
                  value={plan.plan_id} 
                  checked={checked} 
                  onChange={(event)=>this.selectPlan(event, amount)}
                />
                <span className="radiomark1" role="button" />
                <span>
                  <strong>{plan.plan_name}</strong>
                  <span data-hj-whitelist> - {plan.monthly_cost} per month </span>
                  
                  { amount !== plan.monthly_cost && !isMobile &&
                    <span className="strp_amt data-hj-whitelist"> ({amount} {plan.billing_period}) </span> 
                  }
                  
                  { plan.discount !== 0 &&
                    <span className="strp_dis data-hj-whitelist"> Save {plan.discount}% </span> 
                  }
                  { amount !== plan.monthly_cost && isMobile &&
                    <span className="strp_amt mb-only"> {amount} {plan.billing_period} </span> 
                  }
                </span>
              </div>
            )
          })
        }
      </div>    
    )
  }

  selectPlan(event, amount) {
    // const { planId } = this.state
    this.setState({ planId: event.target.value, amount })
  }

  render() {
    const { subscriptionPlan, amount } = this.state
    return(
      <div className="billingInfo">
        <div className="planSection">
          <div className="top-hdng">
            <h2> Upgrade Your Plan </h2>
            <p> Update your payment information, change plans or cancel at any time. </p>
          </div>
          {
            subscriptionPlan.length > 0 &&
            this.displayPlan()
          }
          <div className="chs-plan">
            <h2>Your billing information</h2>
            <StripeProvider apiKey={RoutingConstants.key}>
              <Elements>
                <CardForm onSubmit={(data) => this.onSubmit(data)} amount={amount} {...this.state}/>
              </Elements>
            </StripeProvider>
          </div>
          <div className="bottom-section">
            <h2>
              <img src="/images/lock.svg" alt="secure" />
              Secure Credit Card Payment
            </h2>
            <p>This is a secure 128-bit SSL encrypted payment</p>
          </div>
        </div>
      </div>
          
    )
  }
}

export default BillPayment


// WEBPACK FOOTER //
// ./src/components/billingDetails/BillPayment.js